import { render, staticRenderFns } from "./renewal.vue?vue&type=template&id=1dcaf854&scoped=true"
import script from "./renewal.vue?vue&type=script&lang=js"
export * from "./renewal.vue?vue&type=script&lang=js"
import style0 from "./renewal.vue?vue&type=style&index=0&id=1dcaf854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcaf854",
  null
  
)

export default component.exports